module.exports = __webpack_public_path__ + "static/img/bg_tw.e093850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_tw.png
// module id = aRs+
// module chunks = 2